// 
import analyticsReducer from "./analyticsReducer";
// 
const reducers = {
    analytics : analyticsReducer
}
  
export default reducers;